<script>
  /* eslint-disable */
  import BtnRelatorios from './components/BtnRelatorios.vue'
  import TableRelatorios from './components/TableRelatorios'
  import {list} from '../../domain/callcenter/services'
  import moment from 'moment'
  import date from '../../utils/date'

  export default {
    name: 'Relatorios',
    components: {
      BtnRelatorios,
      TableRelatorios
    },
    data () {
      return {
        loading: false,
        serverPagination: {
          page: 1,
          rowsNumber: 0, // specifying this determines pagination is server-side
          rowsPerPage: 1000
        },
        filtros: {
          periodo: '1',
          data: moment(new Date(), 'L'),
          data1: '',
          data2: '',
          mes: String(moment(new Date(), 'M')),
          ano: String(moment(new Date(), 'YYYY'))
        },
        serverData: null,
        dados: [
          {
            acionado: '19/02/2020 - 11:44',
            remocao: '19/02/2020 - 12:20',
            qtd: '8',
            trajeto: '7km',
            chegada: '19/02/2020 - 13:12'
          },
          {
            acionado: '13/02/2020 - 8:00',
            remocao: '13/02/2020 - 9:23',
            qtd: '14',
            trajeto: '14 km',
            chegada: '13/02/2020 - 10:40'
          }
        ]
      }
    },
    computed: {},
    mounted () {
      this.load()
      // document.querySelector('.u-erp-layout-container').classList.add('bg-white')
    },
    destroyed () {
      // document.querySelector('.u-erp-layout-container').classList.remove('bg-white')
    },
    methods: {
      load () {
        this.request({
          pagination: this.serverPagination,
          filter: this.busca
        })
      },
      request ({pagination, filter}) {
        this.loading = true

        let data1, data2
        if (this.filtros.tipoFiltroData === '-1' && (!this.filtros.data1 || !this.filtros.data2)) {
          alert('Informe um intervalo de datas para processar o filtro')
          return
        }
        if (this.filtros.data1) {
          if (this.filtros.data1.length < 10 || this.filtros.data2.length < 10) {
            alert('Digite a data inicial e data final corretamente')
            return
          }

          data1 = date.datePtToEn(this.filtros.data1)
          data2 = date.datePtToEn(this.filtros.data2)
          if (!date.isValid(data1) || !date.isValid(data2)) {
            alert('Digite a data inicial e data final corretamente. Formato: dd/mm/yyyy')
            return
          }
        } else {
          let substract = Number(this.filtros.tipoFiltroData)
          let newDate = new Date()
          newDate = date.subtractFromDate(newDate, {days: substract})
          data1 = date.formatDate(newDate, 'YYYY-MM-DD')
          data2 = date.formatDate(new Date(), 'YYYY-MM-DD')
        }

        this.loading = true
        let _filter = this.filtros
        let filtros = encodeURI(`&sortBy=id&descending=false&data1=${_filter.data1}&data2=${_filter.data2}&dateFilter=1&search=${filter}`)

        list(pagination.rowsPerPage, pagination.page, filtros)
          .then(({data}) => {
            this.serverPagination = pagination
            this.serverPagination.rowsNumber = data.total
            this.serverData = data.arrayData

            this.loading = false
          })
          .catch(error => {
            this.loading = false
          })
      },
      date (d) {
        let _date = new Date(d)
        return date.formatDate(_date, 'DD/MM/YYYY HH[h]mm')
      },
      dateExt (d) {
        if (typeof d === 'undefined' || !d || null === d) {
          return '-'
        }
        let _date = new Date(d)
        return date.formatDate(_date, 'MMMM - dddd')
      },

      buscaRelatorio (dados) {
        this.filtros.data1 = dados.inicio
        this.filtros.data2 = dados.final
        this.load()
      },

      montaFiltros () {
        let filtros = this.filtros
        let mount = ''
        // Busca
        if (filtros.busca.length > 0) {
          mount += '&busca=' + filtros.busca
        }
        console.log(filtros.tipoPessoa, String(filtros.tipoPessoa).length)
        if (String(filtros.tipoPessoa).length > 0) {
          mount += '&tipo=' + filtros.tipoPessoa
        }
        if (Array.isArray(filtros.situacaoCadastro) && filtros.situacaoCadastro.length > 0) {
          mount += '&status=' + filtros.situacaoCadastro.join(',')
        }
        return mount
      }

    }
  }
</script>

<template>
  <div class="app-content layout-relatorios">
    <div class="app-content-body">
      <btn-relatorios @buscaRelatorio="buscaRelatorio"/>
      <table-relatorios :dados="serverData"/>
    </div>
  </div>
</template>

<style lang="scss"></style>




// WEBPACK FOOTER //
// Main.vue?4945ea71